module.exports = new __parcel__URL__("phone_icon.f5841646.svg").toString();